app.controller("TimetableAddRoomController", [
    "$scope", "TimetableService", "$uibModalInstance", "$state", "$uibModal", "toastr", "StaticData",
    function ($scope, TimetableService, $uibModalInstance, $state, $uibModal, toastr, StaticData) {
        $scope.buildingId = null;
        $scope.name = "";
        $scope.area = 0;
        $scope.count = 1;
        $scope.floor = 1;
        $scope.withComputers = false;
        $scope.withSmartBoard = false;
        $scope.additional = "";

        $scope.fetchBuildings = function () {
            StaticData.getItemsByKey("buildings").then(function (buildings) {
                $scope.buildings = buildings;
            });
        };
        $scope.fetchBuildings();

        $scope.add = function () {
            TimetableService.addRoom({
                name: $scope.name,
                area: $scope.area,
                seatCount: $scope.count,
                floor: $scope.floor,
                building: $scope.buildingId,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard,
                additional: $scope.additional
            }).then(function () {
                toastr.success('', 'ოთახი დამატებულია');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);